import { injectable } from "inversify";
import {
  IGetDataFromHeaders,
  ReturnTypeDownloadFromHeader
} from "./GetDataFromHeaders";
import "reflect-metadata";

@injectable()
export default class HttpFileNameFromHeader implements IGetDataFromHeaders {
  getHeaders(
    headers: Record<string, unknown> | undefined
  ): ReturnTypeDownloadFromHeader {
    if (!headers) return null;

    const contentDisposition = headers["content-disposition"] as string | null;
    const contentType = headers["content-type"] as string | null;

    if (!contentDisposition) return null;

    const [, filename] = contentDisposition.split(";");
    const [, name] = filename.split("=");
    const mimeType = contentType;

    return {
      fileName: name,
      mimeType: mimeType
    };
  }
}
